// extracted by mini-css-extract-plugin
export default {"container":"Mark_container__AcSsA","container__mark":"Mark_container__mark__uQn8X","container__mark__fill":"Mark_container__mark__fill__7yTTe"};